const buildAttemptKey = (orgSlug: string) => `staff-org-auto-join:${orgSlug}`;

export const hasStaffOrgAutoJoinAttempt = (orgSlug: string): boolean =>
  sessionStorage.getItem(buildAttemptKey(orgSlug)) === '1';

export const markStaffOrgAutoJoinAttempt = (orgSlug: string): void => {
  sessionStorage.setItem(buildAttemptKey(orgSlug), '1');
};

export const clearStaffOrgAutoJoinAttempt = (orgSlug: string): void => {
  sessionStorage.removeItem(buildAttemptKey(orgSlug));
};
